import PropTypes from 'prop-types';
import React from 'react';

import styles from './QuantitySelector.css';

class QuantitySelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity: props.defaultQuantity || 1,
    };
  }

  handleQuantityChange(delta) {
    if (delta === -1 && this.state.quantity === 1) {
      return;
    }

    this.setState({
      quantity: this.state.quantity + delta,
    }, () => {
      this.props.onChange(this.state.quantity);
    });
  }

  render() {
    return (
      <div className={styles[`quantity-selector`]}>
        <button
          className={styles[`quantity-button`]}
          disabled={this.state.quantity === 1}
          onClick={this.handleQuantityChange.bind(this, -1)}
        >
          <span className={styles[`quantity-icon-decrease`]}>-</span>
        </button>
        <output className={styles[`quantity-count`]}>{this.props.quantity || this.state.quantity}</output>
        <button
          className={styles[`quantity-button`]}
          onClick={this.handleQuantityChange.bind(this, 1)}
        >
          <span className={styles[`quantity-icon-increase`]}>+</span>
        </button>
      </div>
    );
  }
}

QuantitySelector.propTypes = {
  defaultQuantity: PropTypes.number,
  onChange: PropTypes.func,
  quantity: PropTypes.number,
};

export default QuantitySelector;
